import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button } from '@mui/material';
import { Tree } from './Tree';
import { AppStore } from '../../../store/applicationState';
import { IRubric } from '../../../store/rubrics/types';
import { CreateRubric } from '../../../store/rubrics/actions';
import { BoxModal } from '../../modals';
import { CATEGORIES } from '../../../utils/consts';

type PropsType = {
  level?: number;
};

export const Rubrics: React.FC<PropsType> = ({ level }) => {
  const [cards, setCards] = React.useState<IRubric[] | null>(null);
  const [isModal, setIsModal] = React.useState(false);
  const { Rubrics: RRubrics, Configurations } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (RRubrics.rubrics) {
      if (RRubrics.rubrics[CATEGORIES.NPD]) {
        setCards(RRubrics.rubrics[CATEGORIES.NPD]);
      } else {
        setCards(null);
      }
    }
  }, [RRubrics.rubrics]);

  return (
    <>
      <Box mb={1}>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            setIsModal(true);
          }}
        >
          Створити рубрику
        </Button>
      </Box>
      <Tree rubrics={cards} cards={cards} level={level} categoryId={CATEGORIES.NPD} setCards={setCards} />
      {isModal ? (
        <BoxModal
          title='Створити рубрику'
          handleClose={() => {
            setIsModal(false);
          }}
          handleConfirm={(value) => {
            dispatch(
              CreateRubric.request({
                data: {
                  mainId: null,
                  categoryId: CATEGORIES.NPD,
                  siteId: Configurations.siteId,
                  name: (value as unknown as { title: string; date: Date })?.title || String(value),
                },
              })
            );
            setIsModal(false);
          }}
          open={!!isModal}
        />
      ) : null}
    </>
  );
};
